/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { DtmKadDocCreateRequest } from '../types/DtmKadDocCreate';
import type { DtmKadDocCreateResponse } from '../types/DtmKadDocCreate';

export type DtmKadDocsCreateRequest = DtmKadDocCreateRequest;
export type DtmKadDocsCreateResponse = DtmKadDocCreateResponse;

export type DtmKadDocsCreateQuery = {};

/**
 * POST /dmx-server/dtm_kad_docs/
 *
 * ```yaml
 * operationId: dtm_kad_docs_create
 * tags:
 *   - dtm_kad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmKadDocCreate'
 *     description: ''
 * ```
 */
export const dtmKadDocsCreateOperation = (rest?: DtmKadDocsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/dtm_kad_docs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dtm_kad_docs/' };
  };

/**
 * POST /dmx-server/dtm_kad_docs/
 *
 * ```yaml
 * operationId: dtm_kad_docs_create
 * tags:
 *   - dtm_kad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmKadDocCreate'
 *     description: ''
 * ```
 */
export const dtmKadDocsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: DtmKadDocsCreateQuery;
  request: DtmKadDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DtmKadDocCreateResponse>> => {
  const operation = dtmKadDocsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
